import Paper from "@material-ui/core/es/Paper/Paper";
import * as KJUR from "jsrsasign";
import React from "react";

import ActionBar from "../components/ActionBar";
import Loader from "../components/Loader";
import VLButton from "../components/VLButton";
import * as API from "../util/api";
import VLComponent from "./VLComponent";

export default class ForgotScreen extends VLComponent {

    constructor() {
        super();
        this.state = {loaded: true, rememberMe: true, error: ""};
    }

    componentDidMount() {

    };

    resetUsername = () => {
        let jwt = (this.props.token);
        let obj = KJUR.jws.JWS.readSafeJSONString(KJUR.b64utoutf8(jwt.split("-")[1]));
        return obj.username;
    };

    token = () => {
        return this.props.token.replace(/-/g, ".");
    };

    render() {
        return (
            <div>
                <ActionBar title="Vision Link - Forgot Password" hideAll={true}/>
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    width: "100%",
                    justifyContent: "center",
                    minHeight: "calc(100vh - 120px)",
                    alignItems: "center",
                    padding: 16
                }}>
                    <Paper style={{width: "15cm", padding: 32, borderRadius: 16}}>
                        <div><img src="https://api.vision-link.co.uk/app_logo/VL.png"
                                  style={{width: "calc(100% - 60px)", margin: 30}}/></div>

                        {this.renderForm()}
                        <br/><br/>
                    </Paper>
                    <br/><br/><br/>
                </div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

    renderForm = () => {
        if (this.state.loading) {
            return <div><p style={{textAlign: "center"}}>Loading...</p></div>;
        }
        if (this.state.hasReset) {
            return <div>
                <p style={{textAlign: "center"}}>A password reset email with further instructions has been sent
                    to {this.state.email}</p>
            </div>;
        }
        return (
            <div>
                <p style={{textAlign: "center"}}>Enter your username to reset your password. An email will be
                    sent to the associated account with instructions to reset</p>
                <br/>

                <p className="nomargin"><b>Username</b></p>
                <input name="username" className="vl-input wide top8" placeholder="Username"
                       value={this.state.username} onChange={this.handleInputChange}/>
                <br/><br/>

                <p style={{color: "red", textAlign: "center"}}>{this.state.error}</p>

                <VLButton title="Send Reset Email" className="wide top8" onClick={this.login}/>
            </div>
        );
    };

    login = () => {
        let username = this.state.username;

        this.setState({error: "", loading: true});
        API.POST("account/forgotPassword", {username}, result => {
            if (result.success) {
                let email = result.result.email;
                this.setState({hasReset: true, email});
            } else {
                this.setState({error: result.error});
            }
            this.setState({loading: false});
        });
    };

}
